// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 6929 ? "configure" : chunkId) + "." + {"3748":"79dce12d","6929":"79dce12d","7821":"79dce12d","9227":"79dce12d","9555":"94d14830"}[chunkId] + ".chunk.css";
};